import { useEffect, useState } from "react";
import {
  cancelJoinRequest,
  GameClubDetailResponse,
  getClubDetail,
} from "../../../../api/game-club";
import { useGameClubContext } from "../Hook/GameClubContext";
import {
  GameClubMyDataWrapper,
  GameClubMyWrapper,
} from "../Style/GameClubMyStyles";
import { GameClubMyClub } from "./GameClubMyClubInfo";
import { GameClubMyRank } from "./GameClubMyClubRank";
import { LOCAL_STORAGE_ACCESS_KEY } from "../../../../utils/network";
import GameClubDescription from "./component/GameClubDescription";

export const GameClubMy = () => {
  const {
    myClub,
    setMyClub,
    myJoinRequest,
    setMyJoinRequest,
    resetUserData,
    setResetUserData,
  } = useGameClubContext();

  const handleCancelRequest = async () => {
    if (!myJoinRequest || !myJoinRequest.requestId) return;
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    const accessToken = token ? token.replace("Bearer ", "") : "-";
    try {
      await cancelJoinRequest(myJoinRequest.requestId, accessToken);
      setMyJoinRequest(null);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <GameClubMyWrapper>
      {myClub !== null ? (
        <GameClubMyDataWrapper>
          <GameClubMyClub data={myClub} />
          <GameClubDescription description={myClub.description} />
          <GameClubMyRank data={myClub} setData={setMyClub} />
        </GameClubMyDataWrapper>
      ) : myJoinRequest === null ? (
        <div className="no-data">가입하신 클럽이 없습니다. </div>
      ) : (
        <>
          <div className="no-data">
            {`${myJoinRequest?.name}`} 가입 승인 대기중 입니다.{" "}
            <div className="button" onClick={handleCancelRequest}>
              가입 취소
            </div>
          </div>
        </>
      )}
    </GameClubMyWrapper>
  );
};
